module.exports = "<template> <img src=" + require("./Sabre-Logo-Webseite.png") + " alt=Sabre class=\"img-responsive pull-left\" style=height:2em> </template> ";